export default __webpack_public_path__ + "static/rsouthall-a2370291fbcb1eee68142525dc1fe915.jpg";